import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";
import settingsService from "app/pages/sales-intelligence/sub-modules/advanced-search/services/sw-settings/settingsService";
import type { ICountryObject } from "app/services/CountryService";
import { US_COUNTRY_ID } from "app/services/countryServiceConst";

import ListedAddressFilter from "../../components/filters/ListedAddressFilter/ListedAddressFilter";
import ListedAddressFilterResult from "../../components/filters/ListedAddressFilter/ListedAddressFilterResult";
import { appsFilterCategoryMap } from "../../types/filterCategory";

import FindListedAddressFilter from "./ListedAddressFilter";

const createListedAddressFilter = (): SearchFilterInstance => {
    const allCountries: ICountryObject[] = settingsService
        .getCompanyInformationCountries()
        .filter((c) => c.parent !== US_COUNTRY_ID);

    return {
        key: "listedAddress",
        trackingName: "App Listed Address",
        apiCategory: "appsFilters",
        category: appsFilterCategoryMap.apps,
        title: { key: "si.find_apps.filters.listed-address.title" },
        tooltipText: { key: "si.find_apps.filters.listed-address.tooltip" },
        filter: new FindListedAddressFilter({
            options: allCountries,
        }),
        filterView: ListedAddressFilter,
        filterResultView: ListedAddressFilterResult,
    };
};

export default createListedAddressFilter;
